<template>
    <div class="home-content">
        {{content}}
    </div>
</template>

<script>
    export default {
        name: 'HomeContent',
        props: ['content']
    }
</script>

<style lang="scss" scoped>
    .home-content {
        padding-top: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeContentComponent.vue